export const StrapiMenus = {
  footerMenu: `footer-menu`,
  mainMenu: `main-menu`,
  sidebarClinical: `sidebar-clinical`,
  sidebarLegal: `sidebar-legal`,
  footerLegal: `footer-legal`,
};
